import {Injectable} from '@angular/core';

import 'rxjs/add/operator/toPromise';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {ApiService} from './api.service';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import {Product} from '../model/Entities/Product';
import {Observable} from 'rxjs/Observable';
import {User} from '../model/Entities/User';
import {Availability} from '../model/Entities/Availability';
import {Contract} from '../model/Entities/Contract';
import {Email} from '../model/Entities/Email';

@Injectable()
export class MailService extends ApiService<Email> {

    protected apiUrl = 'api/emails';  // URL to web api

    protected getObjectType(): any {
        return Email;
    }

    public sendEmail(message: Email): Observable<Email> {
        return this.save(message);
    }
}



// WEBPACK FOOTER //
// /app/src/services/mail.service.ts